import { Component } from '@angular/core';

@Component({
  selector: 'app-promt-detail-view',
  imports: [],
  templateUrl: './promt-detail-view.html',
  styleUrl: './promt-detail-view.scss',
})
export class PromtDetailView {

}
